import { render, staticRenderFns } from "./SetСarrier.vue?vue&type=template&id=cfce4676&scoped=true&"
import script from "./SetСarrier.vue?vue&type=script&lang=js&"
export * from "./SetСarrier.vue?vue&type=script&lang=js&"
import style0 from "./SetСarrier.vue?vue&type=style&index=0&id=cfce4676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce4676",
  null
  
)

export default component.exports